export default __webpack_public_path__ + "static/media/cDown.1b821a43.svg";